import { createAction } from 'redux-actions';

interface setLanguageAction extends types.redux.settings.setLanguageAction {}

export const setLanguage: any = createAction('SET_LANGUAGE', (action: setLanguageAction) => action);
